import { Column } from "../../../../core/components/Column";
import { Container } from "../../../../core/components/Container";
import { TextComponent } from "../../../../core/components/TextComponent";
import { ButtonBack, CustomButton } from "../../../../core/components/CustomButton";
import { ErrorMessage, Field, Form, Formik, FormikHelpers } from "formik";
import { EmailFormValues, emailValidationSchema } from "../interfaces/EmailFormInterface";
import { CustomInput } from "../../../../core/components/CustomInput";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AppDispatch } from "../../../../core/store/store";
import { useDispatch } from "react-redux";
import { onSendOtp } from "../store/auth/AuthThunk";
import { LogoTitleBlack } from "../../../../core/components/LogoTitle";
import { useAlert } from "../../../../core/hooks/useAlert";
import { buildAuthQuery } from "../routes/affiliateRedirect";

const initialValues: EmailFormValues = {
  email: ''
};

export const EmailScreen = () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { showAlert } = useAlert();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode") === "reset" ? "reset" : "login";
  const authQuery = buildAuthQuery(
    searchParams.get("intent"),
    searchParams.get("next")
  );
  const handleSubmit = async (values: EmailFormValues, { setSubmitting }: FormikHelpers<EmailFormValues>) => {
    const result = await dispatch(
      onSendOtp({
        email: values.email,
        type: '0'
      })
    );
    if (onSendOtp.fulfilled.match(result)) {
      navigate(`/auth/otp/${values.email}/0?mode=${mode}${authQuery ? `&${authQuery.slice(1)}` : ""}`);
    } else {
      showAlert({
        message: result.error.message || "Could not send the verification code right now.",
        type: "error",
      });
    }
    setSubmitting(false);
  };
  const onBack = () => {
    navigate(-1);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={emailValidationSchema}
      validateOnBlur
      validateOnChange={false}
      onSubmit={handleSubmit}
    >
      {({ handleChange, handleBlur, values }) => (
        <Container className="flex flex-col w-full md:w-1/2 md:justify-center">
          <LogoTitleBlack />
          <Column
            crossAxisAlignment="center"
            className="max-md:bg-black"
          >
            <Column
              mainAxisAlignment="center"
              className="w-full bg-white rounded-tl-3xl max-md:py-14 max-md:px-8 md:mx-24 md:w-1/2"
            >
              <ButtonBack
                onClick={onBack}
                className="relative pb-6 md:p-0 md:absolute md:top-20"
              >
                Go Back
              </ButtonBack>
              <TextComponent variant="h1" className="font-bold">
                Enter your email address
              </TextComponent>
              <TextComponent variant="h6" className="text-gray-500 mt-3">
                {mode === "reset"
                  ? "We will send a verification code so you can verify your account and set a new password."
                  : "We will send you a verification code to your email. After OTP, you can create a password for future logins."}
              </TextComponent>
              <button
                type="button"
                className="mt-3 text-left text-primary underline"
                onClick={() => navigate(`/auth/password${authQuery}`)}
              >
                Already set a password? Login with password
              </button>
              <Form className="mt-5">
                <Field
                  as={CustomInput}
                  name="email"
                  hintText='Enter email address'
                  label="Email Address"
                  type="email"
                  className="form-control"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                />
                <ErrorMessage name="email" component="div" className="text-red-500" />
                <CustomButton type="submit" className="mt-9">
                  Continue
                </CustomButton>
              </Form>
            </Column>
          </Column>
        </Container>
      )}
    </Formik>
  );
}
